module.exports = {
  "metadata": {
    "width": "18",
    "height": "24",
    "name": "arrow-right-sm"
  },
  "source": "<path d=\"M1 13h10v3l6-4-6-4v3H1v2z\"/>"
};